import React, { memo } from 'react';

import Banner from 'components/Banner';
import InfoBlock from 'components/InfoBlock';
import { InfoContent } from 'components/PageSidebar/styles';

import { Wrapper } from './styles';

const MbArchiveSidebar = memo(() => (
  <Wrapper id="mc-sidebar">
    <Banner id="hp-react-banner-premium" slot="bn-slot-premium" />
    <InfoContent>
      <InfoBlock variant="archive" />
    </InfoContent>
  </Wrapper>
));

export default MbArchiveSidebar;
